import { get, post } from '../../utils/request';
import ucenterHttp from '../../utils/ucenterHttp';
import HttpClient from '../../utils/http';
import config from '../../config';

interface ParamsProps {
    id?: number | string;
    surveyId?: number | string;
    channelId?: string;
    projectId?: number | string;
    resource?: any;
}

interface TaskProps {
    projectId: number | string;
    resourceId: number | string;
    resourceType: number | string;
    currentDuration: any;
}

// 获取问卷基本信息详情
export const surveyInfoApi = (params: ParamsProps) => {
    return get(`/api/survey/${params.id}`, {});
};

// 提交问卷
export const saveSurveyApi = (params: ParamsProps) => {
    return post('/api/survey/submit', params);
};

// 问卷结果
export const surveyResultApi = (params: ParamsProps) => {
    return post(`/api/survey/result/${params.id}`, {});
};

// 开始作答
export const beginAnswerApi = (params: ParamsProps) => {
    return get('/api/survey/begin', params);
};

// 获取问卷题目信息列表
export const surveyDetailApi = (params: ParamsProps) => {
    return get(`/api/survey/questions/${params.id}`, {});
};

// 图片上传
export const uploadFileApi = (params: FormData) => {
    return post(`/survey/file`, params, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
};

// 图片批量上传
export const batchUploadFileApi = (params: FormData, options: any) => {
    return post('/survey/batch-files', params, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        ...options,
    });
};

// 模板预览接口
export const templateDetailApi = (params: ParamsProps) => {
    return get(`/api/survey/template/${params.id}`, {});
};

// 问卷提交数据上报 - 培训任务学习
export const trainingTaskStateApi = (params: TaskProps, classauthorization?: string) => {
    return post(`${config.API_HEALTHCLASS_URL}/user/project/doing-task`, params, {
        headers: {
            classauthorization,
        },
    });
};

// 提交问卷 - 培训任务
export const saveTrainSurveyApi = (params: ParamsProps) => {
    return post('/api/survey/healthclass-submit', params);
};

// 通过 ucenter 接口获取用户信息
export function getUserInfoApi(params: { memCard: string }) {
    const url = `${config.UCENTER_URL}/wapi/member/getMemInfo`;
    return ucenterHttp.get(url, params);
}

// 通过 ucenter 接口获取用户信息（含认证）
// 该接口要求 GET 查询参数 data 为 JSON 字符串：data={"memCard":"..."}
export async function getMemAllInfoByMemCard(params: { memCard: string }) {
    if (!params.memCard) {
        return null;
    }
    const url = `${config.UCENTER_URL}/wapi/member6/memberAllInfoByMemCard`;
    const res: any = await ucenterHttp.get(url, { data: `{"memCard":"${params.memCard}"}` });
    if (res?.data) {
        return res.data;
    }
    // 拦截器已解包为会员信息本体时直接返回
    if (res?.baseInfo) {
        return res;
    }
    return null;
}

// 更新用户认证时间
export function updateAuthTime(params: { memCard: string }) {
    const url = `${config.USER_API_URL}/ssoMemberAuth/api/updateAuthTime`;
    return ucenterHttp.post(url, params);
}

// 认证身份字典（code -> name）
export function getAuthDictionaryInfo() {
    if (!config.GATEWAY_API_PREFIX) {
        console.error('未配置 REACT_APP_GATEWAY_API_PREFIX，无法获取认证身份字典');
        return Promise.resolve(null);
    }
    return HttpClient.get('/dataengine/api/authdictionary/json/ex', {});
}

// 查看问卷报告
export const reportCheckApi = (params: { surveyId?: string | number }) => {
    return get('/api/survey/report-check', params);
};

/**
 * 获取文档凭证（令牌）
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getDocPreviewToken(data: any) {
    const url = `${config.VODMEDIA_API_PREFIX}/media/document/get-sign-preshow`;
    return post(url, data);
}

/**
 * 获取视频凭证（令牌）
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */

export function getAliyuncred(data: any) {
    const url = `${config.VODMEDIA_API_PREFIX}/media/video/upload-info`;
    return post(url, data, { timeout: 600000 });
}

// 阿里云OSS刷新凭证
export function refreshAliyuncred(data: any) {
    const url = `${config.VODMEDIA_API_PREFIX}/media/video/re-upload-info`;
    return get(url, data);
}

// export function videoTransCode(data: any) {
//     const url = `${config.VODMEDIA_API_PREFIX}/media/video/stream-upload`;
//     return post(url, data);
// }
